var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80964 16.5237L16.5237 6.80964C16.9781 6.35527 17.2052 6.12808 17.3267 5.883C17.5578 5.41671 17.5578 4.86925 17.3267 4.40295C17.2052 4.15787 16.9781 3.93068 16.5237 3.47631C16.0693 3.02193 15.8421 2.79475 15.597 2.6733C15.1307 2.44223 14.5833 2.44223 14.117 2.6733C13.8719 2.79475 13.6447 3.02193 13.1904 3.47631L3.47631 13.1903C2.99459 13.672 2.75373 13.9129 2.62687 14.2192C2.5 14.5254 2.5 14.8661 2.5 15.5473V17.4999H4.45262C5.13388 17.4999 5.4745 17.4999 5.78078 17.3731C6.08707 17.2462 6.32792 17.0053 6.80964 16.5237Z",
    stroke: "#656F7D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5H15",
    stroke: "#656F7D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 4.58325L15.4168 7.91659",
    stroke: "#656F7D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c8ce5e64295dd4b430769f60a5a71626.svg";
export { ForwardRef as ReactComponent };